import * as React from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import NotFoundPage from './NotFoundPage'
import LoginPage from '../Pages/User/Auth/Login'
import RegisterPage from '../Pages/User/Auth/Register'
import MainStats from '../Pages/User/DashBoard/MainStats'
import SceneStats from '../Pages/User/DashBoard/SceneStats'
import LookUpStats from '../Pages/User/DashBoard/LookUpStats'
import SceneInfo from '../Pages/User/EnvManage/SceneInfo'
import SceneLocation from '../Pages/User/EnvManage/SceneLocation'
import ManageJob from '../Pages/User/EnvManage/ManageJob'
import ManageOrg from '../Pages/User/SysManage/ManageOrg'
import WorkerIntroPage from '../Pages/Worker/WorkerIntroPage'
import WorkerIN from '../Pages/Worker/WorkerIN'
import WorkerOUT from '../Pages/Worker/WorkerOUT'
import DeviceManage from '../Pages/User/IoTManage/DeviceManage'
import Footer from '../Components/Footer'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import EditIcon from '@mui/icons-material/Edit'
import EngineeringIcon from '@mui/icons-material/Engineering'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import WorkIcon from '@mui/icons-material/Work'

import { Button, Box, Typography, Toolbar, CssBaseline, Divider, Stack, Avatar, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

import PropTypes from 'prop-types'
import { styled, alpha } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import MuiAppBar from '@mui/material/AppBar'
import { Menudata, MUI_X_PRODUCTS } from './MenuData'
import { RichTreeView } from '@mui/x-tree-view/RichTreeView'
import LogoutIcon from '@mui/icons-material/Logout'
import { TreeItem, TreeItemProps, treeItemClasses } from '@mui/x-tree-view'
import User1 from '../asset/user1.png'
import mainLogo from '../asset/mainLogo.png'
import HomeIcon from '@mui/icons-material/Home'
import DvrIcon from '@mui/icons-material/Dvr'
import EqualizerIcon from '@mui/icons-material/Equalizer'
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import secureLocalStorage from 'react-secure-storage'
import Api from '../Api/Api'
import CampaignIcon from '@mui/icons-material/Campaign'
import dayjs from 'dayjs'

import quick_icon_1 from '../asset/quick_icon_1.png'
import quick_icon_2 from '../asset/quick_icon_2.png'
import quick_icon_3 from '../asset/quick_icon_3.png'

const styles1 = {
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '15px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#000000',
    fontFamily: 'Noto Sans KR',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '18.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },

  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiTypography-root': {
      color: '#BCBDC4',
      '& fieldset': {
        borderColor: '#BCBDC4',
      },
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '4px',
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
}

const drawerWidth = 240

const openedMixin = (theme) => ({
  background: 'linear-gradient(0deg, #30313A, #30313A),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
})

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
})

const DrawerHeader = styled('div')(({ theme }) => ({
  marginTop: 30,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}))

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer - 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100%)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}))

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      },
    },
  ],
}))

const resultIcon = (label) => {
  switch (label) {
    case '실시간 통계':
      return <DvrIcon style={{ marginRight: 8 }}></DvrIcon>
    case '현장 모니터링':
      return <EqualizerIcon style={{ marginRight: 8 }}></EqualizerIcon>
    case '안전사고 통계 정보 조회':
      return <UpdateRoundedIcon style={{ marginRight: 8 }}></UpdateRoundedIcon>
    case '관리':
      return <SettingsOutlinedIcon style={{ marginRight: 8 }}></SettingsOutlinedIcon>
    case '근로자 작업':
      return <WorkIcon style={{ marginRight: 8 }}></WorkIcon>
    default:
      return
  }
}

const CustomTreeItem = ({ label, ...props }) => {
  return (
    <TreeItem
      label={
        <Stack direction="row" sx={{ fontSize: 17 }}>
          {resultIcon(label)}
          {label}
        </Stack>
      }
      {...props}
    />
  )
}

const CustomTreeItem2 = styled(CustomTreeItem)(({ theme }) => ({
  '& .MuiTreeItem-content.Mui-selected.Mui-focused': {
    borderLeft: '10px solid #7E73FF',
    color: '#ffffff',
  },
  fontFamily: 'Noto Sans KR',
  fontSize: '14px',
  color: '#a2a2a2',
  [`& .${treeItemClasses.content}`]: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.2, 0),
    [`& .${treeItemClasses.label}`]: {
      textAlign: 'left',
      fontSize: '0.8rem',
      fontWeight: 500,
    },
    position: 'relative',

    '&:before': {
      pointerEvents: 'none',
      content: '""',
      position: 'absolute',
      width: 13,
      left: -16,
      top: 12,
      borderBottom: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    '&.Mui-selected.Mui-focused:before': {
      pointerEvents: 'none',
      content: '""',
      position: 'absolute',
      width: 13,
      left: -27,
      top: 12,
      borderBottom: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  },
  [`& .${treeItemClasses.iconContainer}`]: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.dark,
    padding: theme.spacing(0, 1.2),
    ...theme.applyStyles('light', {
      backgroundColor: alpha(theme.palette.primary.main, 0.25),
    }),
    ...theme.applyStyles('dark', {
      color: theme.palette.primary.contrastText,
    }),
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginLeft: 10,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
  // [`& .${treeItemClasses.groupTransition} li:last-child`]: {
  //   marginLeft: 15,
  //   paddingLeft: 18,
  //   borderLeft: `1px dashed  ${alpha(theme.palette.text.primary, 0.4)}`,
  // },
}))
export default function Router() {
  const [access_token, setAccess_token] = React.useState(secureLocalStorage.getItem('access_token'))
  const loginId = secureLocalStorage.getItem('loginId')
  // mark
  const idx = secureLocalStorage.getItem('idx')
  // console.log('Router access_token:', access_token)
  const [open, setOpen] = React.useState(true)
  const [netDeviceList, setNetDeviceList] = React.useState([])
  const [selectedDevice, setSelectedDevice] = React.useState('')
  const [inputMessage, setInputMessage] = React.useState('')
  const location = useLocation() //현재url 정보 가져오기

  const handleInputMessageChange = (event) => {
    setInputMessage(event.target.value)
  }

  const handleSelectedDeviceChange = (event) => {
    setSelectedDevice(event.target.value)
  }

  const navigate = useNavigate()
  const onClickPath = (path) => {
    if (path !== '') {
      navigate(path)
    }
    // console.log('path:', path)
  }
  React.useEffect(() => {}, [access_token])
  React.useEffect(() => {
    getNetDeviceList()
  }, [])

  React.useEffect(() => {
    // console.log('location.pathname:', location.pathname)

    if ((loginId === null || loginId === undefined) && location.pathname !== '/User/Auth/Login') {
      navigate('/User/Auth/Login')
      // alert('로그인이 필요합니다. 관리자에게 문의해 주세요.')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const onClickItem = (id) => {
    let tempPath = ''
    console.log('onClickItem id:', id)

    MUI_X_PRODUCTS.map((item) => {
      if (item.hasOwnProperty('children') === false && item.id === id) {
        tempPath = item.path
      }
      if (item.hasOwnProperty('children')) {
        item.children.map((item2) => {
          if (item2.hasOwnProperty('children') === false && item2.id === id) {
            tempPath = item2.path
          }
          if (item2.hasOwnProperty('children')) {
            item2.children.map((item3) => {
              if (item3.id === id) {
                tempPath = item3.path
              }
            })
          }
        })
      }
    })
    return onClickPath(tempPath)
  }

  function findPathInMenu(origin, target) {
    if (origin.id === target) return [origin.label]
    if (!origin.children) return false
    let path
    const test = origin.children.find((x) => (path = findPathInMenu(x, target)))
    //  console.log("test:",test)
    if (path) {
      return [origin.label].concat(path)
    }
  }

  function findPathInMeneResult(param) {
    let path
    MUI_X_PRODUCTS.map((item) => {
      return [item].find((x) => (path = findPathInMenu(x, param)))
    })
    return path
  }

  // console.log(JSON.stringify(findPathInMeneResult('5_2')))

  const LogOutFun = async () => {
    const headers = {
      Authorization: access_token,
    }

    if (window.confirm('로그아웃 하고 로그인 페이지로 이동하시겠습니까?')) {
      try {
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
        const response = await Api.post('api/v1/auth/logout', null, {
          headers: headers,
        })

        if (response.status === 200) {
          // mark
          try {
            const auditObject = {
              edt: now,
            }
            const response = await Api.patch(`api/v1/audit/${idx}`, auditObject)
          } catch (e2) {
            console.log(`LogOutFun catch e2:`, e2)
          }
          console.log('Logout ok')
          alert('로그아웃 되었습니다.')
          secureLocalStorage.removeItem('idx')
          secureLocalStorage.removeItem('loginId')
          secureLocalStorage.removeItem('access_token')
          secureLocalStorage.removeItem('token_type')
          setAccess_token(null)
          onClickPath('/User/Auth/Login')
        } else {
        }
      } catch (e) {
        //cors headers 값 적용 하지못하는 error로 추후 다시 구현
        console.log('Logout error:', e)
        secureLocalStorage.removeItem('idx')
        secureLocalStorage.removeItem('loginId')
        secureLocalStorage.removeItem('access_token')
        secureLocalStorage.removeItem('token_type')
        setAccess_token(null)
        onClickPath('/User/Auth/Login')
      }
    }
  }

  //퀵메뉴
  const actions = [
    {
      icon: <img src={quick_icon_3} style={{ width: 30, height: 30 }} onClick={() => handleDialogOpen()} />,
      name: 'TTS',
    },
    {
      icon: (
        <img
          src={quick_icon_2}
          style={{ width: 30, height: 30 }}
          onClick={() => onClickPath('/User/DashBoard/SceneStats')}
        />
      ),
      name: '모니터링',
    },
    {
      icon: (
        <img
          src={quick_icon_1}
          style={{ width: 30, height: 30 }}
          onClick={() => onClickPath('/User/EnvManage/SceneInfo')}
        />
      ),
      name: '작업등록',
    },
  ]
  function nullCheck(param) {
    if (param !== undefined && param !== null && param !== '') {
      return false
    }
    if (param === undefined || param === null || param === '') {
      return true
    }
  }

  //관리 시설
  const sendTTS = async () => {
    const tempObject = {
      uid: loginId,
      di: selectedDevice,
      ct: inputMessage,
    }
    if (nullCheck(selectedDevice) === false && nullCheck(inputMessage) === false) {
      // /api/v1/am/tts/{device_id}
      console.log('sendTTS object:', tempObject)
      try {
        const response = await Api.post(`/api/v1/am/tts/${selectedDevice}`, tempObject)
        if (response.status === 200) {
          alert('send TTS 서버응답 코드 ok')
          // console.log('getItem3 response.data:', response.data)
          console.log('sendTTS response.data:', response.data)
          setSelectedDevice('')
          setInputMessage('')
          handleDialogClose()
        }
      } catch (e) {
        alert(`send TTS 서버응답 에러 ${e}`)
        console.log('sendTTS exception:', e)
      }
    } else {
      alert('장비가 선택되지 않았거나 보낼 메세지가 없습니다.')
    }
  }

  const getNetDeviceList = async () => {
    let tempList = []
    try {
      const response = await Api.get('/api/v1/devices/?ckNetDevice=true')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        console.log('getNetDeviceList response.data', response.data)
        response.data.map((item) => {
          if (item.dsi === 'Gateway') {
            tempList.push(item)
          }
        })
        setNetDeviceList(tempList)
      }
      // console.log('getOrgName response.data', response.data)
    } catch (e) {
      console.log('getNetDeviceList exception', e)
    }
  }
  const [openDialog, setOpenDialog] = React.useState(false)

  const handleDialogOpen = () => {
    setOpenDialog(true)
  }

  const handleDialogClose = () => {
    setOpenDialog(false)
  }

  // function move_main_confirm() {
  //   console.log('move_main_confirm')
  //   if (window.confirm('로그아웃 하고 처음화면으로 이동합니다.')) {
  //     LogOutFun()
  //   } else {
  //   }
  // }
  return (
    // mark
    <div className="main">
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          // PaperProps={{
          //   component: 'form',
          //   onSubmit: (event) => {
          //     event.preventDefault();
          //     const formData = new FormData(event.currentTarget);
          //     const formJson = Object.fromEntries(formData.entries());
          //     const email = formJson.email;
          //     console.log(email);
          //     handleClose();
          //   },
          // }}
        >
          <DialogContent
            sx={{
              background: '#2F2E41',
            }}
          >
            <Typography sx={[styles1.Typography2, { marginTop: 2, color: '#ffffff', fontSize: 24 }]}>TTS</Typography>
            <Box sx={{ minWidth: 420, marginTop: 4 }}>
              <FormControl fullWidth>
                <InputLabel sx={styles1.Typography1} id="demo-simple-select-label">
                  네트워크 장비 선택
                </InputLabel>
                <Select
                  sx={[styles1.Select1]}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedDevice}
                  onChange={handleSelectedDeviceChange}
                >
                  {netDeviceList.map((item, index) => (
                    <MenuItem key={index} value={item.di}>
                      {`설치장소:${item.orglist[item.orglist.length - 1]} / 장비명:${item.dname}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <TextField
              sx={[styles1.Select1, { marginTop: 3 }]}
              autoFocus
              required
              margin="dense"
              fullWidth
              label="보낼 메세지 입력"
              value={inputMessage}
              onChange={handleInputMessageChange}
            />
          </DialogContent>
          <DialogActions sx={{ background: '#2F2E41' }}>
            <Button
              sx={{
                marginBottom: 2,
                borderRadius: '5px',
                background: 'linear-gradient(180deg, #5E5F67 0%, #454546 100%)',
              }}
              variant="contained"
              onClick={handleDialogClose}
            >
              취소
            </Button>
            <Button
              sx={{
                marginRight: 3,
                marginBottom: 2,
                borderRadius: '5px',
                background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
              }}
              variant="contained"
              onClick={() => sendTTS()}
            >
              보내기
            </Button>
          </DialogActions>
        </Dialog>
        {access_token !== null ? (
          <AppBar
            elevation={0}
            position="fixed"
            open={open}
            sx={{
              marginLeft: 200,
              height: 43,
              background:
                'linear-gradient(0deg, #30313A, #30313A), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
            }}
          >
            <Toolbar
              variant="dense"
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'center',
                height: 30,
              }}
            >
              <Stack direction="row" spacing={2}>
                <div style={{ marginTop: 7 }}>
                  <Avatar src={User1} sx={{ height: 20, width: 20 }}>
                    H
                  </Avatar>
                </div>

                <Typography
                  noWrap
                  component="div"
                  sx={{
                    alignContent: 'center',
                    mt: 1,
                    fontFamily: 'Noto Sans KR',
                    fontSize: '12px',
                    fontWeight: 400,
                    lineHeight: '17.38px',
                    textAlign: 'left',
                  }}
                >
                  반갑습니다 {loginId}님.!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
                </Typography>
                <Button onClick={() => LogOutFun()}>
                  <LogoutIcon sx={{ color: '#A2A2A8', height: 16, width: 16 }} />
                  <Typography
                    noWrap
                    component="div"
                    sx={{
                      ml: 1,
                      mt: 0.5,
                      color: '#A2A2A8',
                      fontFamily: 'Noto Sans KR',
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '17.38px',
                      textAlign: 'left',
                    }}
                  >
                    로그아웃
                  </Typography>
                </Button>
              </Stack>
            </Toolbar>
          </AppBar>
        ) : (
          ''
        )}

        {access_token !== null && location.pathname !== '/User/Auth/Login' ? (
          <div>
            <Drawer
              variant="permanent"
              open={open}
              sx={{
                '& .MuiDrawer-paper': {
                  width: '280px !important',
                },
              }}
            >
              <DrawerHeader
                sx={{
                  justifyContent: 'center',
                  background:
                    'linear-gradient(0deg, #30313A, #30313A),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
                }}
              >
                <div onClick={() => LogOutFun()}>
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      alignItems: 'center',
                      alignContent: 'center',
                      justifyContent: 'center',
                      justifyItems: 'center',
                    }}
                  >
                    <img style={{ marginTop: 3, height: 24, width: 24 }} src={mainLogo}></img>
                    <Typography
                      sx={{
                        color: '#ffffff',
                        fontFamily: 'Monomaniac One',
                        fontSize: '24px',
                        fontWeight: 800,
                        lineHeight: '34.75px',
                        textAlign: 'left',
                        textUnderlinePosition: 'from-font',
                        textDecorationSkipInk: 'none',
                      }}
                    >
                      BaRon-M2M
                    </Typography>
                  </Stack>
                </div>

                {/* {open === false ? (
                  <Button variant="contained" onClick={handleDrawerOpen}>
                    <ChevronRightIcon />
                  </Button>
                ) : (
                  <Button variant="contained" onClick={handleDrawerClose}>
                    <ChevronLeftIcon />
                  </Button>
                )} */}
              </DrawerHeader>
              <DrawerHeader
                sx={{
                  justifyContent: 'center',
                  background:
                    'linear-gradient(0deg, #30313A, #30313A),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
                }}
              >
                <Button
                  onClick={() => onClickPath('/User/DashBoard/MainStats')}
                  variant="contained"
                  sx={{
                    backdropFilter: 'blur(53px)',
                    boxShadow: '-8px 4px 5px 0px #0000003d',
                    borderRadius: '3px',
                    background:
                      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 15.98%, rgba(0, 0, 0, 0) 36.28%)',
                    border: '1px solid #afafaf',
                    borderImageSource:
                      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
                    width: 205,
                    height: 33,
                  }}
                >
                  <HomeIcon sx={{ backgroundColor: '#linear-gradient(180deg, #4061CF 0%, #5921CB 100%)' }} />
                  <Typography
                    sx={{
                      color: '#AFAFAF',
                      ml: 2,
                      fontFamily: 'Noto Sans KR',
                      fontSize: '16px',
                      fontWeight: 700,
                    }}
                  >
                    Home
                  </Typography>
                </Button>
              </DrawerHeader>
              <Divider />
              <RichTreeView
                slots={{ item: CustomTreeItem2 }}
                items={MUI_X_PRODUCTS}
                expansionTrigger="content"
                onItemClick={(event, itemId) => onClickItem(itemId)}
              />
            </Drawer>
            <Box
              sx={{
                position: 'fixed',
                bottom: '0%',
                right: 15,
                zIndex: 1000,
                height: 320,
                transform: 'translateZ(0px)',
                flexGrow: 1,
              }}
            >
              <SpeedDial
                ariaLabel="SpeedDial openIcon example"
                sx={{ position: 'absolute', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon openIcon={<EditIcon />} />}
              >
                {actions.map((action) => (
                  <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} />
                ))}
              </SpeedDial>
            </Box>
            {/* <Box
              sx={{
                backgroundColor: '#ff00ff',
                height: '100px',
                width: '100px',
                position: 'fixed',
                bottom: '0%',
                right: 15,
                zIndex: 1000,
              }}
            >
              <Stack alignItems="center" gap={0} onClick={() => console.log('클릭1')}>
                <MenuIcon />
                <Typography sx={{ fontSize: 14.5, color: '#000000', fontWeight: 1000 }}>
                  바로가기1<br></br>
                </Typography>
              </Stack>
              <Stack alignItems="center" gap={0} onClick={() => console.log('클릭2')}>
                <MenuIcon />
                <Typography sx={{ fontSize: 14.5, color: '#000000', fontWeight: 1000 }}>
                  바로가기2<br></br>
                </Typography>
              </Stack>
            </Box> */}
          </div>
        ) : (
          ''
        )}

        <Box component="main" sx={{ flexGrow: 1, minHeight: 2000, marginLeft: 5 }}>
          <DrawerHeader />
          <Routes>
            <Route exact path="/" element={<MainStats />} />
            <Route exact path={'*'} element={<NotFoundPage />} />
            <Route exact path={'/User/Auth/Login'} element={<LoginPage />} />
            <Route exact path={'/User/Auth/Register'} element={<RegisterPage />} />
            <Route exact path={'/User/DashBoard/MainStats'} element={<MainStats />} />
            <Route exact path={'/User/DashBoard/SceneStats'} element={<SceneStats />} />
            <Route exact path={'/User/DashBoard/LookUpStats'} element={<LookUpStats />} />
            <Route exact path={'/User/EnvManage/SceneInfo'} element={<SceneInfo />} />
            <Route exact path={'/User/EnvManage/SceneLocation'} element={<SceneLocation />} />
            <Route exact path={'/User/EnvManage/ManageJob'} element={<ManageJob />} />
            <Route exact path={'/User/SysManage/:PATH'} element={<ManageOrg />} />
            {/* <Route exact path={'/User/SysManage/AccountManage'} element={<AccountManage />} />
            <Route exact path={'/User/SysManage/LogManage'} element={<LogManage />} /> */}
            <Route exact path={'/Worker/WorkerIntroPage'} element={<WorkerIntroPage />} />
            <Route exact path={'/Worker/WorkerIN'} element={<WorkerIN />} />
            <Route exact path={'/Worker/WorkerOUT'} element={<WorkerOUT />} />
            <Route exact path={'/User/IoTManage/:PATH'} element={<DeviceManage />} />
            {/* <Route exact path={'/User/IoTManage/GroupManage'} element={<GroupManage />} />
            <Route exact path={'/User/IoTManage/OTA'} element={<OTA />} /> */}

            {/* <Route path="/main/:PATH" element={<MainPage />} /> */}
          </Routes>
          {access_token !== null ? <Footer></Footer> : ''}
        </Box>
      </Box>
    </div>
  )
}
Router.propTypes = {
  window: PropTypes.func,
}
